import { User } from '../../../models/user.model';
import { IRegisteredAddress, RegisteredAddress } from '../../../models/registered-address.model';
import { Address, IAddress } from '../../../models/address.model';
import { Contact, IContact } from '../../../models/contact.model';
import { AddressTypeEnum } from '../../../models/enums/address-type.enum';
import { TransportFormGroup } from '../../../models/forms/TransportFormGroup';

export class RegisteredAddressMapper {
  static getAddress(registredAddress: IRegisteredAddress): IAddress {
    return new Address({
      fullname: registredAddress.fullname,
      streetNumber: registredAddress.streetNumber,
      street: registredAddress.street,
      zipCode: registredAddress.zipCode,
      city: registredAddress.city,
      cityCode: registredAddress.cityCode,
      country: registredAddress.country,
      additionals: registredAddress.additionals,
    });
  }

  static getContact(registredAddress: IRegisteredAddress): IContact {
    return new Contact(
      registredAddress.contactCivility,
      registredAddress.contactFirstName,
      registredAddress.contactLastName,
      registredAddress.contactMail,
      registredAddress.contactPhone
    );
  }

  static updateContactRegisteredAddress(registredAddress: IRegisteredAddress, contact: IContact): void {
    registredAddress.contactCivility = contact.civility;
    registredAddress.contactFirstName = contact.firstName;
    registredAddress.contactLastName = contact.lastName;
    registredAddress.contactMail = contact.mail;
    registredAddress.contactPhone = contact.phone;
  }

  static getAddressType(registeredAddress: IRegisteredAddress): AddressTypeEnum {
    if (registeredAddress.pickupUser && registeredAddress.deliveryUser) {
      return AddressTypeEnum.BOTH;
    } else if (registeredAddress.pickupUser) {
      return AddressTypeEnum.PICKUP;
    } else {
      return AddressTypeEnum.DELIVERY;
    }
  }

  static extractAsRegisteredAddress(transportFormGroup: TransportFormGroup, user: User, isPickup = true): IRegisteredAddress {
    let registeredAddress: IRegisteredAddress;
    if (isPickup) {
      registeredAddress = RegisteredAddressMapper.toRegisteredAddress(transportFormGroup.controls.pickupAddress.value());
      registeredAddress.pickupUser = user;
      registeredAddress.loadingConstraint = transportFormGroup.controls.pickupLoadingConstraint.value ?? undefined;
      registeredAddress.accessConstraint = transportFormGroup.controls.pickupAccessConstraint.value ?? undefined;
      const contact = transportFormGroup.controls.pickupContact;
      registeredAddress.contactCivility = contact.controls.civility.value ?? undefined;
      registeredAddress.contactMail = contact.controls.mail.value ?? undefined;
      registeredAddress.contactPhone = contact.controls.phone.value ?? undefined;
      registeredAddress.contactFirstName = contact.controls.firstName.value ?? undefined;
      registeredAddress.contactLastName = contact.controls.lastName.value ?? undefined;
    } else {
      registeredAddress = RegisteredAddressMapper.toRegisteredAddress(transportFormGroup.controls.deliveryAddress.value());
      registeredAddress.deliveryUser = user;
      registeredAddress.loadingConstraint = transportFormGroup.controls.deliveryLoadingConstraint.value ?? undefined;
      registeredAddress.accessConstraint = transportFormGroup.controls.deliveryAccessConstraint.value ?? undefined;
      const contact = transportFormGroup.controls.deliveryContact;
      registeredAddress.contactCivility = contact.controls.civility.value ?? undefined;
      registeredAddress.contactMail = contact.controls.mail.value ?? undefined;
      registeredAddress.contactPhone = contact.controls.phone.value ?? undefined;
      registeredAddress.contactFirstName = contact.controls.firstName.value ?? undefined;
      registeredAddress.contactLastName = contact.controls.lastName.value ?? undefined;
    }

    return registeredAddress;
  }

  static toRegisteredAddress(address: IAddress): IRegisteredAddress {
    const registeredAddresss = new RegisteredAddress();
    registeredAddresss.fullname = address.fullname ?? undefined;
    registeredAddresss.streetNumber = address.streetNumber ?? undefined;
    registeredAddresss.street = address.street ?? undefined;
    registeredAddresss.zipCode = address.zipCode ?? undefined;
    registeredAddresss.city = address.city ?? undefined;
    registeredAddresss.cityCode = address.cityCode ?? undefined;
    registeredAddresss.country = address.country ?? undefined;
    registeredAddresss.additionals = address.additionals ?? undefined;

    return registeredAddresss;
  }
}
